var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"design-editor-btn-wrap"},[_c('button',{staticClass:"deploy",on:{"click":_vm.deployDesign}},[_vm._v("쇼핑몰 적용")]),_c('a',{staticClass:"design",attrs:{"href":"/design/editor","target":"_blank"}},[_vm._v("디자인 변경")])])}
var staticRenderFns = []

export { render, staticRenderFns }